import ClassNames from 'classnames'
import React from 'react'
import {
  Section
} from './../../../../components'
import {
  WarrantyAdditionalInformationWrapper
} from './styled'

export class WarrantyBSWMIndonesiaAdditionalInformation extends React.PureComponent {
  render() {
    const {
      additionalProjectInformation,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'warranty-bswm-additional-information',
    )

    return (
      <WarrantyAdditionalInformationWrapper
        className={classes}
      >
        <Section spacingBottom='10'>
          <Section spacingBottom='5'><p className='warranty-bswm-text is-sm'>Additional Project Information:</p></Section>
          <p className='warranty-bswm-text is-sm is-bold'>{additionalProjectInformation}</p>
        </Section>
      </WarrantyAdditionalInformationWrapper>
    )
  }

  static defaultProps = {
    additionalProjectInformation: '< Additional Project Information >',
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
